import {api} from '@/http'

// 日历记事列表
const getNoteList = (data, callback, back) => {
  api('/api/Note/List', 'post', data, callback, back)
}

// 日历记事添加
const addNote = (data, callback, back) => {
  api('/api/Note/Insert', 'post', data, callback, back)
}

// 日历记事删除
const delNote = (id, callback, back) => {
  api('/api/Note/Delete', 'post', {Id: id}, callback, back)
}

// 最新消息
const getHomeNews = (callback, back) => {
  api('/api/News/HomeNews', 'post', {}, callback, back)
}

// 待处理事项
const getHomePadding = (callback, back) => {
  api('/api/home/PenddingList', 'post', {}, callback, back)
}

// 未完成
const getHomePayList = (callback, back) => {
  api('/api/Home/PayList', 'post', {}, callback, back)
}

// 未完成数字
const getHomePayNums = (callback, back) => {
  api('/api/Home/PayNums', 'post', {}, callback, back)
}

export default {
  getNoteList,
  addNote,
  delNote,
  getHomeNews,
  getHomePadding,
  getHomePayList,
  getHomePayNums
}



// WEBPACK FOOTER //
// ./src/api/home/index.js